(() => {
  if (customElements.get('cart-upsell')) {
    return;
  }

  class CartUpsell extends HTMLElement {
    /**
     * On Submit.
     *
     * @param {Event} event
     */
    onSubmit(event) {
      event.preventDefault();

      // Read the variant at click time rather than caching it on construction.
      // The cart drawer re-render reuses these elements and rewrites
      // data-variant in place, and because cart-upsells.liquid skips products
      // already in the cart, every card shifts up a slot after each add. An id
      // captured once belongs to the product that used to sit in this slot, so
      // adding the second add-on would bump the quantity of the first instead.
      const variantId = this.getAttribute('data-variant');
      if (!variantId) {
        return;
      }

      const config = fetchConfigDefaults("application/javascript");
      const formData = new FormData();
      formData.append('id', variantId);
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      config.body = formData;
      fetch(`${theme.routes.cart_add_url}`, config)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          console.log(status);
          return;
        }
        document.dispatchEvent(
          new CustomEvent('theme:update:cart', {
            bubbles: true,
          })
        );
      })
      .catch(error => {
        console.error(error)
      });
    }

    /**
     * Connected callback.
     *
     * @returns {Void}
     */
    connectedCallback() {
      this.buyButton = this.querySelector('[data-buy-button]');
      if (!this.buyButton) {
        return;
      }
      this.buyButton.addEventListener('click', this.onSubmit.bind(this));
    }
  }

  customElements.define('cart-upsell', CartUpsell);
})();
